<template>
    <div>
        <el-button type="primary" class="onlyBtn" @click="showManyCardImport">批量导入</el-button>
        <el-button type="primary" class="onlyBtn" @click="showOneCardImport">单卡导入</el-button>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="createTime" label="导入时间"></el-table-column>
            <el-table-column prop="batchNo" label="导入批次"></el-table-column>
            <el-table-column prop="importTotal" label="导入张数（张）"></el-table-column>
            <el-table-column prop="importSuccess" label="导入成功张数（张）"></el-table-column>
            <el-table-column prop="importFail" label="导入失败张数（张）"></el-table-column>
            <el-table-column prop="agentName" label="卡片归属"></el-table-column>
            <el-table-column prop="pkgGroupName" label="套餐组名称"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"></el-table-column>
            <el-table-column prop="supplierTypeName" label="运营商"></el-table-column>
            <el-table-column prop="cardTypeName" label="卡类型"></el-table-column>
            <el-table-column prop="createOptName" label="操作人"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.importFail > 0" type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm"  label-width="100px">
                <template v-if="batchImport">
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('sim/import')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=import')">导出模板</el-button>
                        </el-upload>                        
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="ICCID号：" prop="iccid">
                        <el-input v-model.trim="importCardForm.iccid" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="接入号：" prop="intoNo">
                        <el-input v-model.trim="importCardForm.intoNo" clearable></el-input>
                    </el-form-item> 
                </template>   
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="importCardForm.agentId" filterable clearable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>                    
                </el-form-item>
                <el-form-item label="供应商：" prop="supplierCode">
                    <el-select v-model="importCardForm.supplierCode" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="`${item.name+' ( '+item.alias+' )'}`"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐组：" prop="basePkgGroup">
                    <el-select v-model="importCardForm.basePkgGroup" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡类型：" prop="cardType">
                    <el-select v-model="importCardForm.cardType">
                        <el-option v-for="item in simTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="激活赠送："  prop="isReward">
                    <el-radio-group v-model="importCardForm.isReward">
                        <el-radio label="1">赠送</el-radio>
                        <el-radio label="0">不赠送</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="导入失败卡列表" :visible.sync="importFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="failReason" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import {oneCardImport, getImportRecordList, getImportFailRecordList} from '@/api/sim.js'
import {getSimTypeOption} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){   
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }
        return {            
            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            importCardForm: {
                iccid: '',
                intoNo: '',
                agentId: '',
                supplierCode: '',
                basePkgGroup: '',
                cardType: '',                
                isReward: '0'
            },
            importCardVisible: false,
            batchImport: true,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },       
            currentId_fail: '',
            pkgGroup: [],
            agentListOption: [],
            branchSupplierOption: [],
            simTypeOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                iccid: [{required: true, validator: this.checkIccid, trigger: 'blur'}],
                intoNo: [{required: true, validator: this.checkIntoNo, trigger: 'blur'}],
                supplierCode: [{required: true, message: '请选择供应商', trigger: 'change'}],
                basePkgGroup: [{required: true, message: '请选择套餐组', trigger: 'change'}],
                cardType: [{required: true, message: '请选择卡类型', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){            
            this.importCardVisible = false; 
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', {});
            getImportRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event){
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                recordId: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport(){
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
            this.batchImport = true;
        },        
        showOneCardImport(){
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "单卡导入";
            this.batchImport = false;
        },
        getOptionsOfSelect(){       
            common.getAgentListOptionCom(this, 'agentListOption');
            common.getPkgGroupListCom(this, 'pkgGroup');
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
            getSimTypeOption().then(res => {
                if(res.data.code == 200){
                    this.simTypeOption = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }              
            })
        },
        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    if(this.batchImport){
                        this.$refs.upload.submit();   //号段批量导入
                    }else{
                        var data = this.importCardForm;
                        oneCardImport(data).then(res => {
                            if(res.data.code == 200){
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                            }else{
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                }
            })           
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }  
    },
    created () {
        this.getImportRecordListHandle();
    } 
}
</script>

<style lang="less" scoped>

</style>

